import { ReactNode } from 'react';

interface ILabelProps {
  required?: boolean;
  id: string;
  children: ReactNode;
  labelClassname?: string;
}
const Label = ({
  required = false,
  id,
  children,
  labelClassname,
}: ILabelProps) => {
  return (
    <label htmlFor={id} className={`form-label ${labelClassname} `}>
      {children}
      {required && <span className="text-danger">*</span>}
    </label>
  );
};
export default Label;
